import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsBasketSelected = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>


	  <path fill="currentColor" d="M12,0.6666667c-6.2592354,0-11.333333,5.0740981-11.333333,11.333333
	c0,6.2591915,5.0740981,11.333334,11.333333,11.333334c6.2591915,0,11.333334-5.0741425,11.333334-11.333334
	C23.333334,5.7407646,18.2591915,0.6666667,12,0.6666667z M10.5251837,16.0960789l-4.1487398-4.1502123l1.0894551-1.0909281
	l3.0585704,3.0592842l5.9883881-6.0095873l1.1128407,1.0909281L10.5251837,16.0960789z"/>
    </SvgIcon>
  );
});

export default AppIconsBasketSelected;
